<template>
    <div class="fields selection" :class="{ 'checked': selection.participants.indexOf(participant.id) > -1}">
        <input type="checkbox" name="participants[]" :id="participant.id" :value="participant.id" v-model="selection.participants" v-bind:disabled="!available"/>
        <label :for="participant.id">
            <div class="checkbox">
            </div>

            <div class="title">
                {{ name.joined }} <small>(DOB: {{dob}})</small>
            </div>

            <div class="subtitle red" v-if="!available">
                {{ $parent.$parent.locale.text_existing_child_wrong_enough }}
            </div>
        </label>
    </div>
</template>

<script>
    String.prototype.capitalize = function() {
        return this.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
    };

    export default {
        data () {
            return {
                selected: [],
            }
        },
        props: ['participant', 'quickadd', 'available', 'selection'],
        watch: {
            "selected": function () {
                if(this.selected.indexOf(this.participant.id) > -1)
                    this.$emit('addchosen', this.participant.id);
                else
                    this.$emit('removechosen', this.participant.id);
            },
            "quickadd": function () {
                if(this.quickadd && this.available)
                    this.selected.push(this.participant.id);
            },
            "available": function () {
                if(this.quickadd && this.available)
                    this.selected.push(this.participant.id);
            },

        },
        computed: {
            name: function() {
                return {
                    joined: (this.participant.first_name + " " + this.participant.last_name),
                    first: this.participant.first_name.capitalize(),
                    last: this.participant.last_name.capitalize()
                }
            },
            dob: function() {
                var date = this.participant.dob.toDate();
                return date.toShortDateString(true, '-', 'short', true);;
            },
        },
        created () {
            if(this.quickadd && this.available)
                this.selected.push(this.participant.id);
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// ExistingParticipant.vue?1b8f5048